import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/leave')({ component: LeaveLayout });

/** Layout della sezione Richieste/Ferie: index (hub) e /new (form) nidificati. */
function LeaveLayout() {
  return <Outlet />;
}
